(() => {
  if (window.__conversionTableTouchHoverInstalled) return;
  window.__conversionTableTouchHoverInstalled = true;

  const cellSelector = '.table_component table th, .table_component table td, .table_component_scroll table th, .table_component_scroll table td';

  const getColumnMap = (table) => {
    const cellColumns = new Map();
    const occupied = [];

    [...table.rows].forEach((row, rowIndex) => {
      if (!occupied[rowIndex]) occupied[rowIndex] = [];
      let column = 0;

      [...row.cells].forEach((cell) => {
        while (occupied[rowIndex][column]) column++;
        const columns = [];
        const colspan = cell.colSpan || 1;
        const rowspan = cell.rowSpan || 1;

        for (let offset = 0; offset < colspan; offset++) {
          const currentColumn = column + offset;
          columns.push(currentColumn);
          for (let down = 0; down < rowspan; down++) {
            if (!occupied[rowIndex + down]) occupied[rowIndex + down] = [];
            occupied[rowIndex + down][currentColumn] = true;
          }
        }

        cellColumns.set(cell, columns);
        column += colspan;
      });
    });

    return cellColumns;
  };

  const clearHover = (table) => {
    table.querySelectorAll('.is-hovered-row, .is-hovered-column, .is-hovered-cell')
      .forEach((element) => {
        element.classList.remove('is-hovered-row', 'is-hovered-column', 'is-hovered-cell');
      });
  };

  const selectCell = (cell) => {
    const table = cell.closest('table');
    if (!table) return;

    const cellColumns = getColumnMap(table);
    const activeColumns = new Set(cellColumns.get(cell) || []);

    clearHover(table);
    cell.parentElement.classList.add('is-hovered-row');
    cell.classList.add('is-hovered-cell');

    table.querySelectorAll('th, td').forEach((otherCell) => {
      const columns = cellColumns.get(otherCell) || [];
      if (columns.some((column) => activeColumns.has(column))) {
        otherCell.classList.add('is-hovered-column');
      }
    });
  };

  // Mouse users get normal hover behavior.
  document.addEventListener('pointerover', (event) => {
    if (event.pointerType === 'touch') return;
    const cell = event.target.closest(cellSelector);
    if (cell) selectCell(cell);
  });

  // Touch users tap once to keep the row and column selected.
  document.addEventListener('click', (event) => {
    const cell = event.target.closest(cellSelector);
    if (cell) {
      selectCell(cell);
    } else {
      document.querySelectorAll('.table_component table, .table_component_scroll table').forEach(clearHover);
    }
  });

  // Clear mouse hover when leaving a table. Tap selections are not cleared by this.
  document.addEventListener('pointerout', (event) => {
    if (event.pointerType === 'touch') return;
    const cell = event.target.closest(cellSelector);
    if (!cell || (event.relatedTarget && cell.contains(event.relatedTarget))) return;

    const table = cell.closest('table');
    if (table && !table.contains(event.relatedTarget)) clearHover(table);
  });
})();
